// import { initializeApp } from 'firebase/app';
import { 
		getFirestore, 
		collection, 
		doc, 
		setDoc, 
		getDoc,
		addDoc, 
		deleteDoc, 
		query, 
		where, 
		// select, 
		limit,
		getDocs,
		serverTimestamp,
		documentId,
		updateDoc, 
		arrayUnion,
		orderBy,
		FieldValue,
	 } from 'firebase/firestore';

import firebaseApp from './firebase.js';
import obj_rm_empty from 'xAppLib/helpers/obj_rm_empty.js';

const db = getFirestore(firebaseApp);

const DEBUG = false;

export default class firebase_firestore {

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async set_record(collectionName, docId, d, p) {

		if (p?.timestamp) {
			d.tm = serverTimestamp();
			d.tm_str = new Date().toString();
		}

		if (p?.add_by)
			d.by = {
						u: app.user?.uid,
						un: app.user?.prof?.username,
						// n: app.user?.user_det?.displayName,
						// e: app.user?.user_det?.email,
						d: app.dvc?.dvcid,
						cc: app.user?.cc,
						ct: app.user?.loc_city || app.user?.prof?.city,
					};

		d = obj_rm_empty(d, {exc_instof: [FieldValue]});
		DEBUG && console.log('firebase_firestore.set_record : ', collectionName, docId, d);

		try {
			await setDoc(doc(db, collectionName, docId), d);
			DEBUG && console.log('firebase_firestore.set_record : Document successfully written!', collectionName, docId);
		} catch (error) {
			console.error('firebase_firestore.set_record : Error writing document: ', collectionName, docId, error);
		}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async add_record(collectionName, d, p) {

		if (p?.timestamp) {
			d.tm = serverTimestamp();
			d.tm_str = new Date().toString();
		}

		if (p?.add_by)
			d.by = {
						u: app.user?.uid,
						un: app.user?.prof?.username,
						// n: app.user?.user_det?.displayName,
						// e: app.user?.user_det?.email,
						d: app.dvc?.dvcid,
						cc: app.user?.cc,
						ct: app.user?.loc_city || app.user?.prof?.city,
					};

		d = obj_rm_empty(d, {exc_instof: [FieldValue]});
		DEBUG && console.log('firebase_firestore.add_record : ', collectionName, d);

		try {
			const docRef = await addDoc(collection(db, collectionName), d);
			DEBUG && console.log("firebase_firestore.add_record : Document written with ID: ", collectionName, docRef.id);
			return docRef.id;
		} catch (error) {
			console.error('firebase_firestore.add_record : Error writing document: ', collectionName, d, error);
		}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async insert_record(collectionName, docId, arr, d, p) {

		if (p?.timestamp) {
			d.tm = Date.now();  // Use client timestamp for array elements (serverTimestamp() doesn't work in arrayUnion)
			d.tm_str = new Date().toString();
		}

		if (p?.add_by)
			d.by = {
						u: app.user?.uid,
						un: app.user?.prof?.username,
						// n: app.user?.user_det?.displayName,
						// e: app.user?.user_det?.email,
						d: app.dvc?.dvcid,
						cc: app.user?.cc,
						ct: app.user?.loc_city || app.user?.prof?.city,
					};

		d = obj_rm_empty(d, {exc_instof: [FieldValue]});
		DEBUG && console.log("firebase_firestore.insert_record : ", collectionName, docId, arr, d);

		try {

			const docRef = doc(db, collectionName, docId);

			await updateDoc(docRef, { [arr]: arrayUnion(d) });

			DEBUG && console.log("firebase_firestore.insert_record : Record added to array in document: ", collectionName, docId, arr);

		} catch (error) {
			console.error('firebase_firestore.insert_record : Error writing document: ', collectionName, docId, arr, error);
		}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async update_record(collectionName, docId, d, p) {

		if (p?.timestamp) {
			d.tm = serverTimestamp();
			d.tm_str = new Date().toString();
		}

		if (p?.add_by)
			d.by = {
						u: app.user?.uid,
						un: app.user?.prof?.username,
						// n: app.user?.user_det?.displayName,
						// e: app.user?.user_det?.email,
						d: app.dvc?.dvcid,
						cc: app.user?.cc,
						ct: app.user?.loc_city || app.user?.prof?.city,
					};

		d = obj_rm_empty(d, {exc_instof: [FieldValue]});
		DEBUG && console.log('firebase_firestore.update_record : ', collectionName, docId, d);
		
		try {
			const docRef = doc(db, collectionName, docId);
			await updateDoc(docRef, d);
			DEBUG && console.log("firebase_firestore.update_record : Document updated successfully!", collectionName, docId);
		} catch (error) {	
			console.error('firebase_firestore.update_record : Error writing document: ', collectionName, docId, d, error);
		}
	}


	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async getDocument(collectionName, docId, p) {
		let docRef, docSnap;
		DEBUG && console.log('firebase_firestore.getDocument : ', collectionName, docId, p);

		try {
			docRef = doc(db, collectionName, docId);
			docSnap = await getDoc(docRef);
			if (docSnap.exists()) {
				const data = docSnap.data();

				if (p?.flds?.length > 0) {
					return p?.flds.reduce((filtered, field) => {
						if (data[field] !== undefined) {
							filtered[field] = data[field];
						}
						return filtered;
					}, {});
				}

				return data;
			} else {
				console.warn('firebase_firestore.getDocument : No such document!', collectionName, docId);
			}
		} catch (error) {
			console.error('firebase_firestore.getDocument : Error getting document: ', error, docRef, docSnap, db, collectionName, docId);
		}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------
	/*
	static async getDocument3(collectionName, docId, p) {

		const fields = p?.flds;
		DEBUG && console.log('getDocument', collectionName, docId, fields);

		try {
			// Build the base query
			let baseQuery = query(
				collection(db, collectionName),
				where("__name__", "==", docId) // Firestore internal field for document ID
			);

			// If specific fields are provided, add the `select` clause
			if (fields?.length > 0) {
				baseQuery = query(baseQuery, select(...fields));
			}

			DEBUG && console.log('baseQuery', baseQuery, collectionName, docId, fields);

			// Fetch the document
			const querySnapshot = await getDocs(baseQuery);
			if (!querySnapshot.empty) {
				return querySnapshot.docs[0].data(); // Return the first document's data
			} else {
				console.warn("No such document!", collectionName, docId);
				return null;
			}
		} catch (error) {
			console.error("Error getting document: ", error, { db, collectionName, docId, fields });
			return null;
		}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async getDocument2(collectionName, docId) {
		let docRef, docSnap;
		try {
			docRef = doc(db, collectionName, docId);
			// docSnap = await getDoc(docRef);
			docSnap = await getDoc(docRef, { fieldMask: {'word':true, 'max_guesses':true, 'dict':true} });


			const l = await db
				.collection(collectionName)
				.where(documentId(), "==", docId)
				.select("word", "max_guesses")
				.get();
			DEBUG && console.log('selected ', l);
				// db.collection(<collection_name>).select(‘id’,‘distance’).get()

			DEBUG && console.log('docSnap', docSnap);
			if (docSnap.exists()) {
				return docSnap.data();

			} else {
				console.warn('No such document!', collectionName, docId);
			}
		} catch (error) {
			console.error('Error getting document: ', error, docRef, docSnap, db, collectionName, docId);
		}
	}
	*/

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async _deleteDocument(collectionName, docId) {
		try {
			await deleteDoc(doc(db, collectionName, docId));
			DEBUG && console.log('Document successfully deleted!');
		} catch (error) {
			console.error('Error deleting document: ', error);
		}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async queryDocuments(collectionName, p) {
		try {

			DEBUG && console.log('firebase_firestore.queryDocuments : ', collectionName, p);

			const queryConstraints = []
			if (p?.fld && p?.fld_val)	queryConstraints.push( where(p?.fld, p?.fld_op||"==", p?.fld_val) )
			if (p?.fld2 && p?.fld2_val)	queryConstraints.push( where(p?.fld2, p?.fld2_op||"==", p?.fld2_val) )
			if (p?.ord_by)	queryConstraints.push( orderBy(p?.ord_by, p?.ord_dir||"asc") )

			const q = query(collection(db, collectionName), ...queryConstraints)

			// let q;
			// if (p?.fld && p?.fld_val) 
			// 	q = query(collection(db, collectionName), where(p?.fld, p?.fld_op||"==", p?.fld_val));
			// else
			// 	q = query(collection(db, collectionName));

			const querySnapshot = await getDocs(q);
			const results = [];

			let i=0;
			querySnapshot.forEach(doc => {
				results.push({
								...(p?.add_id && {[p.add_id]: doc.id}),
								...(p?.add_enum && {[p.add_enum]: ++i}),
								...doc.data()
							});
			});

			DEBUG && console.log('firebase_firestore.queryDocuments : results', collectionName, p, results);

			return results;
		} catch (error) {
			console.error('firebase_firestore.queryDocuments : Error querying documents: ', collectionName, p, error);
		}
	}
	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

}